"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var markdown_it_1 = __importDefault(require("markdown-it"));

function rules(_ref) {
  var _ref$rules = _ref.rules,
      rules = _ref$rules === void 0 ? {} : _ref$rules,
      _ref$plugins = _ref.plugins,
      plugins = _ref$plugins === void 0 ? [] : _ref$plugins;
  var markdownIt = markdown_it_1.default("default", Object.assign({
    breaks: false,
    html: false,
    linkify: false
  }, rules));
  plugins.forEach(function (plugin) {
    return markdownIt.use(plugin);
  });
  return markdownIt;
}

exports.default = rules;